<div class="florder-page" @fadeInAnimation>
  <div class="florder-page-title">
    <span class="title">
      {{ 'RELOCATIONS.LIST.SUBTITLE' | translate }}
    </span>
    <div class="buttons">
      <eps-button (buttonClick)="createFlorder()" *ngIf="userContext.isEpsUser && userContext.canRelocate" buttonIcon="plus-square" label="ORDERS.FILTER.BUTTONS.ADD_RELOCATION"></eps-button>
      <eps-button type="primary" (buttonClick)="createTemplate()" *ngIf="userContext.isEpsUser && userContext.canRelocate" buttonIcon="plus-square" label="ORDERS.FILTER.BUTTONS.ADD_TEMPLATE"></eps-button>
      <eps-button type="primary" (buttonClick)="gotoCalendar()" *ngIf="userContext.isEpsUser && userContext.canRelocate" buttonIcon="calendar" label="SHARED.HEADER.CALENDAR"></eps-button>
    </div>
  </div>
  <div>
    <div class="florder-page-search">
      <app-relocation-filter
        [definitions]="definitions"
        [filter]="filter"
        [isLoading]="ordersAreLoading"
        [isBusy]="isDownloading"
        (filterRelocations)="filterFlorders($event)"
      ></app-relocation-filter>
    </div>
    <div class="florder-page-list" id="relocations-list">
      <app-relocation-list
        [definitions]="definitions"
        [filter]="filter"
        [isLoading]="ordersAreLoading"
        [relocations]="relocations.items"
        [totalItems]="relocations.totalItems"
        [authorization]="authorization"
        [userContext]="userContext"
        (openRelocation)="openRelocation($event)"
        (copyRelocation)="copyRelocation($event)"
        (asTemplate)="asTemplate($event)"
        (sortChange)="sortChange($event)"
        (pageChange)="onPageChange($event)"
        (itemsPerPageChange)="onItemsPerPageChange($event)"
      ></app-relocation-list>
    </div>
  </div>
</div>
